/**
 * Tax Toolbox tool registry.
 *
 * Mirrors the shape of `src/fdd/types.ts` so the two toolboxes stay
 * recognisably the same thing to a reader.
 */
export type TaxToolId = "reconstruct" | "scorp";

export interface TaxTool {
  id: TaxToolId;
  name: string;
  description: string;
  icon: string;
  /** True when the tool is listed for visibility but hasn't been built yet. */
  comingSoon?: boolean;
}

export const TAX_TOOLS: TaxTool[] = [
  {
    id: "reconstruct",
    name: "Return Reconstruction",
    description:
      "Upload everything, see an inventory of every form and tax year found, then rebuild the chosen returns and the deal book for side-by-side review",
    icon: "🪞",
  },
  {
    id: "scorp",
    name: "S-Corp Diligence",
    description:
      "Scan the data room for the documents an S-corp review needs, add what is missing, then read everything into one timeline with the contradictions, answers and requests",
    icon: "🏛️",
  },
];
